import { RwcMessageType, DefaultTitle, } from './constants';
export class Chat {
    static launchChatBotWindow(config, data) {
        window.onmessage = (e) => {
            var _a;
            if (e.data.type === RwcMessageType.GET_TOKEN) {
                (_a = e.source) === null || _a === void 0 ? void 0 : _a.postMessage(Object.assign(config, {
                    type: RwcMessageType.SET_TOKEN,
                    data,
                }), '*');
            }
        };
        const url = config.chatUrl;
        const title = config.title || DefaultTitle;
        const windowDimensions = {
            width: config.width || 835,
            height: config.height || 600,
        };
        const y = window.outerHeight / 2 + window.screenY - windowDimensions.height / 2;
        const x = window.outerWidth / 2 + window.screenX - windowDimensions.width / 2;
        const params = `
        toolbar=no,
        location=no,
        directories=no,
        status=no,
        menubar=no,
        resizable=no,
        copyhistory=no,
        scrollbars=no,
        width=${windowDimensions.width},
        height=${windowDimensions.height},
        top=${y},
        left=${x}
    `;
        const newWindow = window.open(url, title, params);
        if (newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus) {
            newWindow.focus();
        }
    }
}
//# sourceMappingURL=Chat.js.map